import { render, staticRenderFns } from "./DoctorsFilter.vue?vue&type=template&id=fa7caa7c&"
import script from "./DoctorsFilter.vue?vue&type=script&lang=js&"
export * from "./DoctorsFilter.vue?vue&type=script&lang=js&"
import style0 from "./DoctorsFilter.vue?vue&type=style&index=0&id=fa7caa7c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports